import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_3 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_4 = { class: "flex items-center mb-8" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "h-24 w-24 rounded-full bg-primary/20 flex items-center justify-center overflow-hidden" }
const _hoisted_7 = {
  key: 0,
  class: "text-4xl font-semibold text-primary"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ml-6" }
const _hoisted_10 = { class: "text-xl font-semibold" }
const _hoisted_11 = { class: "text-muted-foreground" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "pt-4 border-t border-border"
}
const _hoisted_20 = {
  key: 0,
  class: "p-3 bg-green-100 text-green-700 rounded-md mb-3"
}
const _hoisted_21 = {
  key: 1,
  class: "p-3 bg-red-100 text-red-700 rounded-md mb-3"
}
const _hoisted_22 = {
  key: 2,
  class: "p-3 bg-red-100 text-red-700 rounded-md mb-3"
}
const _hoisted_23 = { class: "flex justify-end space-x-3" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "space-y-6" }
const _hoisted_28 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_31 = {
  key: 1,
  class: "animate-spin h-5 w-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_35 = {
  key: 0,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_36 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-md p-6" }
const _hoisted_37 = { class: "flex justify-end space-x-3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MicrosoftConnectCard = _resolveComponent("MicrosoftConnectCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[27] || (_cache[27] = _createElementVNode("h1", { class: "text-2xl font-bold mb-6" }, "User Settings", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.userData?.avatar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.userInitials), 1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.userData.avatar,
                    alt: "User avatar",
                    class: "h-full w-full object-cover"
                  }, null, 8, _hoisted_8))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("button", {
              class: "absolute bottom-0 right-0 bg-primary text-primary-foreground rounded-full p-1 shadow-md hover:bg-primary/90 transition-colors",
              title: "Change avatar"
            }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                })
              ])
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.userData?.name || 'User Name'), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.userData?.email || 'user@example.com'), 1)
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent"])),
          class: "space-y-6"
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                for: "name",
                class: "block text-sm font-medium mb-1"
              }, "Full Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
                placeholder: "Your full name"
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                for: "email",
                class: "block text-sm font-medium mb-1"
              }, "Email Address", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
                placeholder: "your.email@example.com"
              }, null, 512), [
                [_vModelText, _ctx.form.email]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                for: "username",
                class: "block text-sm font-medium mb-1"
              }, "Username", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "username",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.username) = $event)),
                class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
                placeholder: "username"
              }, null, 512), [
                [_vModelText, _ctx.form.username]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                for: "system_role",
                class: "block text-sm font-medium mb-1"
              }, "System Role", -1)),
              _createElementVNode("input", {
                type: "text",
                id: "system_role",
                value: _ctx.formatSystemRole(_ctx.form.system_role as SystemRole),
                class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
                placeholder: "Your system role",
                disabled: ""
              }, null, 8, _hoisted_13)
            ]),
            _createElementVNode("div", null, [
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "business_role",
                class: "block text-sm font-medium mb-1"
              }, "Business Role", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "business_role",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.business_role) = $event)),
                class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
                disabled: _ctx.form.system_role !== _ctx.SystemRole.ADMIN
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessRoles, (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: role,
                    value: role
                  }, _toDisplayString(_ctx.formatBusinessRole(role)), 9, _hoisted_15))
                }), 128))
              ], 8, _hoisted_14), [
                [_vModelSelect, _ctx.form.business_role]
              ])
            ]),
            (_ctx.form.business_role === _ctx.BusinessRole.PLANNER)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", {
                    for: "report_type",
                    class: "block text-sm font-medium mb-1"
                  }, "Report Type", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "report_type",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.report_type) = $event)),
                    class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
                    disabled: _ctx.form.system_role !== _ctx.SystemRole.ADMIN
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTypes, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type,
                        value: type
                      }, _toDisplayString(_ctx.formatReportType(type)), 9, _hoisted_18))
                    }), 128))
                  ], 8, _hoisted_17), [
                    [_vModelSelect, _ctx.form.report_type]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.successMessage || _ctx.error || _ctx.passwordError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_ctx.successMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.successMessage), 1))
                  : _createCommentVNode("", true),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.error.message), 1))
                  : _createCommentVNode("", true),
                (_ctx.passwordError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.passwordError), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              type: "button",
              class: "px-4 py-2 border border-input rounded-md hover:bg-accent transition-colors",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "submit",
              class: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Saving..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_26, "Save Changes"))
            ], 8, _hoisted_24)
          ])
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_MicrosoftConnectCard, {
          userId: _ctx.userData?.id || (_ctx.userData?.profile?.id || ''),
          userEmail: _ctx.userData?.email || (_ctx.userData?.profile?.email || ''),
          onMicrosoftConnected: _ctx.handleMicrosoftConnected,
          onMicrosoftDisconnected: _ctx.handleMicrosoftDisconnected
        }, null, 8, ["userId", "userEmail", "onMicrosoftConnected", "onMicrosoftDisconnected"]),
        _createElementVNode("div", _hoisted_28, [
          _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Personal Data", -1)),
          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Download a copy of your personal data stored in our system including your profile information and preferences ", -1)),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.downloadPersonalData && _ctx.downloadPersonalData(...args))),
            class: "flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
            disabled: _ctx.downloadLoading
          }, [
            (!_ctx.downloadLoading)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_30, _cache[18] || (_cache[18] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("svg", _hoisted_31, _cache[19] || (_cache[19] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ]))),
            (_ctx.downloadLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Downloading..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_33, "Download My Data"))
          ], 8, _hoisted_29)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Account Management", -1)),
          _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Manage your account settings including account deletion ", -1)),
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDeleteConfirmation = true)),
            class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors flex items-center"
          }, _cache[22] || (_cache[22] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-5 w-5 mr-2",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              })
            ], -1),
            _createTextVNode(" Delete My Account ")
          ]))
        ]),
        (_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-medium mb-3 dark:text-white" }, "Confirm Account Deletion", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-300 mb-6" }, " Are you sure you want to delete your account? This action cannot be undone and all your data will be permanently removed. ", -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteConfirmation = false)),
                    class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.deleteAccount && _ctx.deleteAccount(...args))),
                    class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors",
                    disabled: _ctx.isDeleting
                  }, [
                    (_ctx.isDeleting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Deleting..."))
                      : (_openBlock(), _createElementBlock("span", _hoisted_40, "Delete Account"))
                  ], 8, _hoisted_38)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}